import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  selector: ".number-only",
})
export class NumberDirective {
  @Input() numbersOnly: number = 0;
  
  constructor() {}

  @HostListener("keypress", ["$event"]) keyPress(e: KeyboardEvent): boolean | void {
    let key: number = Number(e.key);

    if (isNaN(key)) {
      return false;
    }
  }
}
